/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contributions_NoneInputs */

const en_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No contributions`)
};

const ar_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا مساهمات`)
};

const bn_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনো কন্ট্রিবিউশন নেই`)
};

const de_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Beiträge`)
};

const es_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin contribuciones`)
};

const fr_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune contribution`)
};

const pt_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem contribuições`)
};

const zh_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无贡献`)
};

const tr_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katkı yok`)
};

const ru_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет вкладов`)
};

const pl_contributions_none = /** @type {(inputs: Contributions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak kontrybucji`)
};

/**
* | output |
* | --- |
* | "No contributions" |
*
* @param {Contributions_NoneInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contributions_none = /** @type {((inputs?: Contributions_NoneInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contributions_NoneInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contributions_none(inputs)
	if (locale === "bn") return bn_contributions_none(inputs)
	if (locale === "de") return de_contributions_none(inputs)
	if (locale === "es") return es_contributions_none(inputs)
	if (locale === "fr") return fr_contributions_none(inputs)
	if (locale === "pt") return pt_contributions_none(inputs)
	if (locale === "zh") return zh_contributions_none(inputs)
	if (locale === "tr") return tr_contributions_none(inputs)
	if (locale === "ru") return ru_contributions_none(inputs)
	if (locale === "pl") return pl_contributions_none(inputs)
	return en_contributions_none(inputs)
});